/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Has_LoggiaInputs */

const cs_form_has_loggia = /** @type {(inputs: Form_Has_LoggiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lodžie`)
};

const en_form_has_loggia = /** @type {(inputs: Form_Has_LoggiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loggia`)
};

/**
* | output |
* | --- |
* | "Loggia" |
*
* @param {Form_Has_LoggiaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_has_loggia = /** @type {((inputs?: Form_Has_LoggiaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Has_LoggiaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_has_loggia(inputs)
	return cs_form_has_loggia(inputs)
});